const validatePhotoThumbAndSignData = (data) => {
  const errors = [];

  if (!data.image || !data.image.startsWith("data:image/jpeg;base64,")) {
    errors.push("Invalid image format.");
  }
  if (!data.name || typeof data.name !== "string" || data.name.trim() === "") {
    errors.push("Name must be a non-empty string.");
  }
  // if (!data.pcode || !/^\d{4}$/.test(data.pcode)) {
  //   errors.push("pCode must be a 4-digit string.");
  // }
  if (!data.pCode || !/^\d{4}$/.test(data.pCode)) {
    errors.push("pCode must be a 4-digit string.");
  }

  if (!data.sign || !data.sign.startsWith("data:image/bmp;base64,")) {
    errors.push("Invalid sign format.");
  }
  if (!data.thumbimg || !data.thumbimg.startsWith("data:image/bmp;base64,")) {
    errors.push("Invalid thumb format.");
  }
  if (!data.thumb || !data.thumb.startsWith("Rk1SACA")) {
    errors.push("Invalid thumb format.");
  }

  return errors;
};

export default validatePhotoThumbAndSignData;
